<header class="bg-dark py-5">
  <div class="container px-4 px-lg-5 my-5">
    <div class="text-center text-white">
      <h1 class="display-4 fw-bolder">Nisi nisi et ex commodo mollit.</h1>
      <p class="lead fw-normal text-white-50 mb-0">
        Duis aute tempor nisi mollit commodo deserunt Lorem eiusmod officia qui
        excepteur.
      </p>
    </div>
  </div>
</header>

<main>
  <ng-container
    *ngIf="{
      listOne: listOneProducts$ | async,
      listTwo: listTwoProducts$ | async
    } as products"
  >
    <ng-container *ngIf="products.listOne; else spinner">
      <section class="py-5">
        <div class="container px-4 px-lg-5 mt-5">
          <div class="row gx-4 gx-lg-5 justify-content-center">
            <ng-container *ngIf="products.listOne as products">
              <app-carousel [products]="products"></app-carousel>
            </ng-container>
          </div>
        </div>
      </section>
    </ng-container>

    <section class="random-banner"></section>

    <ng-container *ngIf="products.listTwo; else spinner">
      <section class="py-5">
        <div class="container px-4 px-lg-5 mt-5">
          <div class="row gx-4 gx-lg-5 justify-content-center">
            <ng-container *ngIf="products.listTwo as products">
              <app-carousel [products]="products"></app-carousel>
            </ng-container>
          </div>
        </div>
      </section>
    </ng-container>
  </ng-container>
</main>

<ng-template #spinner>
  <app-spinner></app-spinner>
</ng-template>
